import useSize from '@react-hook/size';

const BASE_WIDTH = 1024;
const BASE_HEIGHT = 768;

export function getZoom(target: { width: number; height: number }, base?: { width: number; height: number }): number {
    const zoomX = target.width / (base?.width ?? BASE_WIDTH);
    const zoomY = target.height / (base?.height ?? BASE_HEIGHT);

    return zoomX < zoomY ? zoomX : zoomY;
}

export const useZoom = <T extends HTMLElement, U extends HTMLElement>(target: U | React.RefObject<U | null>, canvas: T | React.RefObject<T | null> | null | undefined): number => {
    // @ts-expect-error: @react-hook/size does not support React 19 types, we should replace it
    const [twidth, theight] = useSize(target);
    // @ts-expect-error: @react-hook/size does not support React 19 types, we should replace it
    const [cwidth, cheight] = useSize(canvas ?? null);

    return getZoom({ width: twidth, height: theight }, canvas ? { width: cwidth, height: cheight } : undefined);
};
